import React from "react";
import { Form } from "antd";
import { Select } from "./BaseSelect";
import PrintStatus from "../../../enum/PrintStatus";

const PrintStatusField: React.FC = React.memo(() => {
    return (
        <Form.Item label={<span className="search-field-label">打印状态</span>} name="printStatus">
            <Select
                options={[
                    {
                        value: PrintStatus.NONE,
                        label: "",
                    },
                    {
                        value: PrintStatus.NOT_PRINT_WAYBILL,
                        label: "未打印快递单",
                    },
                    {
                        value: PrintStatus.NOT_PRINT_PACKING_LIST,
                        label: "未打印发货单",
                    },
                    {
                        value: PrintStatus.NOT_ORDER_ITEM_LABEL_PRINTED,
                        label: "未打印订单商品标签",
                    },
                    {
                        value: PrintStatus.PRINTED_WAYBILL,
                        label: "已打印快递单",
                    },
                    {
                        value: PrintStatus.PRINTED_PACKING_LIST,
                        label: "已打印发货单",
                    },
                    {
                        value: PrintStatus.ORDER_ITEM_LABEL_PRINTED,
                        label: "已打印订单商品标签",
                    },
                    {
                        value: PrintStatus.PRINT_WAYBILL_COUNT_EQ_1,
                        label: "快递单打印次数=1",
                    },
                    {
                        value: PrintStatus.PRINT_WAYBILL_COUNT_GT_1,
                        label: "快递单打印次数>1",
                    },
                    {
                        value: PrintStatus.WAYBILL_NO_GENERATED_ONLY,
                        label: "仅获取单号不打印",
                    },
                    {
                        value: PrintStatus.PURCHASING_LABEL_PRINTED,
                        label: "已打印拿货标签",
                    },
                    {
                        value: PrintStatus.NOT_PURCHASING_LABEL_PRINTED,
                        label: "未打印拿货标签",
                    },
                ]}
            />
        </Form.Item>
    );
});

export default PrintStatusField;
